<template>
    <div>
        <bc-dialog :value="override_dialog" max-width="300px" transition="dialog-bottom-transition" overlay="false" scrollable>
            <v-card>
                <v-card-text>
                    <v-form ref="overrideForm">
                        <v-container>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <v-text-field v-model="override_code" label="Supervisor Override Pin"></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @click="close()">Cancel</v-btn>
                    <v-btn color="primary" @click="submitOverride()">Override</v-btn>
                </v-card-actions>
            </v-card>
        </bc-dialog>
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import AppConfig from "Constants/AppConfig";
import axios from "axios";
//TODO: custom filter for the v-combo to search for email as well as name
export default {
    data() {
        return {
            override_code: "",
            override_dialog: false,
        };
    },
    methods: {
        ...mapActions(["submitOverrideCode"]),
        close() {
            this.override_dialog = false;
            this.override_code = "";
        },
        openDialog() {
            this.override_dialog = true;
        },
        submitOverride() {
            this.submitOverrideCode({ pin: this.override_code }).then((response) => {
                if (response.success) {
                    this.$emit("eventname", true);
                    this.close();
                } else {
                    this.$store.commit("showSnackbar", {
                        text: response.data.message,
                        color: "error",
                    });
                }
            });
        },
    },
    computed: {
        ...mapState({
            user: (state) => state.AppActiveUser.user,
            user_is_dev: (state) => state.AppActiveUser.user_is_dev,
        }),
    },
};
</script>
